var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal--menu",on:{"click":function($event){$event.stopPropagation();return _vm.$store.commit('closeMenu')}}},[_c('div',{staticClass:"modal--menu__body"},[_c('user-detail')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }